import { render, staticRenderFns } from "./vatDetailBox.vue?vue&type=template&id=32b47a4b&"
import script from "./vatDetailBox.vue?vue&type=script&lang=ts&"
export * from "./vatDetailBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports